(() => {
  const init = root => {
    root.querySelectorAll('.bmg-about-nav,.bmg-services__nav,.bmg-discover__nav,.bmg-contact-nav').forEach(nav => {
      if (nav.hasAttribute('data-bmg-navigation-bound')) return;
      let wrapper = nav.closest('.bmg-section-navigation');
      let summary = wrapper?.querySelector(':scope > summary');
      if (!wrapper) {
        wrapper = document.createElement('details'); wrapper.className = 'bmg-section-navigation'; wrapper.open = true;
        summary = document.createElement('summary');
        const current = nav.querySelector('[aria-current="page"]');
        summary.textContent = (nav.getAttribute('aria-label') || 'Explore this section') + (current ? ' · ' + current.textContent.trim() : '');
        nav.before(wrapper); wrapper.append(summary,nav);
      }
      if (!summary) return;
      nav.setAttribute('data-bmg-navigation-bound','');
      const media = window.matchMedia('(max-width:650px)');
      const adapt = () => {wrapper.open = !media.matches;};
      if (wrapper.dataset.bmgInitialCompact !== String(media.matches)) adapt();
      delete wrapper.dataset.bmgInitialCompact;
      media.addEventListener('change',adapt);
      if (nav.classList.contains('bmg-contact-nav')) {
        wrapper.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !media.matches || !wrapper.open) return;
          wrapper.open = false; summary.focus(); event.preventDefault();
        });
      }
      nav.addEventListener('click', event => {
        if (!media.matches || !event.target.closest('a')?.getAttribute('href')?.startsWith('#')) return;
        wrapper.open = false;
      });
    });
    root.querySelectorAll('.bmg-editorial__intro,.bmg-services__intro').forEach(intro => {
      if (intro.querySelector('.bmg-early-actions') || location.pathname.endsWith('/request-a-quote')) return;
      const action = document.createElement('div'); action.className = 'bmg-early-actions';
      const link = document.createElement('a'); link.href = '/pages/request-a-quote'; link.className = 'bmg-action bmg-action--secondary'; link.textContent = document.body.dataset.bmgEarlyQuote || 'Discuss your requirements';
      action.append(link);intro.append(action);
    });
    // Preserve the existing contextual labels; move decorative arrow characters outside their accessible name.
    root.querySelectorAll('.bmg-page-cta,.bmg-services__button,.bmg-services__submit,.bmg-discover__button,.bmg-action').forEach(link => {
      for (const node of [...link.childNodes]) {
        if (node.nodeType !== Node.TEXT_NODE || !/[→↗]\s*$/.test(node.textContent)) continue;
        const arrow = document.createElement('span'); arrow.setAttribute('aria-hidden','true'); arrow.textContent = node.textContent.trim().slice(-1);
        node.textContent = node.textContent.replace(/\s*[→↗]\s*$/,''); link.append(arrow);
      }
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (!customElements.get('back-to-top')) customElements.define('back-to-top', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController(); const signal = this.controller.signal;
      this.update = () => {
        const focusedField = document.activeElement?.matches('input,textarea,select,iframe');
        const viewport = window.visualViewport;
        const keyboard = viewport && viewport.height < window.innerHeight * .75;
        this.classList.toggle('show',window.scrollY > 400 && !focusedField && !keyboard);
        // Lift the control above the footer; hide it if it intersects a visible form.
        const rect = this.getBoundingClientRect();
        const obstructsForm = [...document.querySelectorAll('.bmg-event-controls,.bmg-signup-form,.bmg-services__attachment-form,.contact-form')].some(form => {const r=form.getBoundingClientRect();return r.top < rect.bottom && r.bottom > rect.top && r.right > rect.left && r.left < rect.right;});
        this.classList.toggle('bmg-top-obstructed',obstructsForm);
      };
      this.addEventListener('click', () => {
        window.scrollTo({top:0,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
        document.querySelector('.header__logo a')?.focus({preventScroll:true});
      },{signal});
      window.addEventListener('scroll',this.update,{passive:true,signal});
      document.addEventListener('focusin',this.update,{signal}); document.addEventListener('focusout',this.update,{signal});
      window.visualViewport?.addEventListener('resize',this.update,{signal});this.update();
    }
    disconnectedCallback(){this.controller?.abort();}
  });
})();


// Carry public page context into the existing enquiry form without changing its destination or visible copy.
(() => {
  const pageDefaults = {"procurement-sourcing":["Procurement & Sourcing","Procurement & Sourcing"],"logistics-delivery":["Logistics & Delivery","Logistics & Delivery"],"technical-project-support":["Technical & Project Support","Technical & Project Support"],"utility-scale-solutions":["Utility-Scale Solutions","Utility-Scale Solutions"],"financing-commercial-support":["Financing & Commercial Support","Financing & Commercial Support"],"partner-services":["Partner Services","Partner Services"],"sell-to-bmg":["Stock offer","Sell to BMG"],"vrs-holdings":["Other — please describe below","VRS Holding"],"events":["Other — please describe below","Events"],"brands-manufacturers":["Product enquiry / quotation","Brands & Manufacturers"],"jinkosolar":["Product enquiry / quotation","JinkoSolar"],"ja-solar":["Product enquiry / quotation","JA Solar"],"aiko":["Product enquiry / quotation","AIKO"],"longi":["Product enquiry / quotation","LONGi"],"trina-solar":["Product enquiry / quotation","Trina Solar"],"huawei":["Product enquiry / quotation","Huawei"],"sungrow":["Product enquiry / quotation","Sungrow"],"solis":["Product enquiry / quotation","Solis"],"deye":["Product enquiry / quotation","Deye"],"byd":["Product enquiry / quotation","BYD"],"goodwe":["Product enquiry / quotation","GoodWe"],"sigenergy":["Product enquiry / quotation","Sigenergy"],"dyness":["Product enquiry / quotation","Dyness"],"k2":["Product enquiry / quotation","K2"],"schletter":["Product enquiry / quotation","Schletter"],"esdec":["Product enquiry / quotation","Esdec"],"contact":[null,"Contact"],"request-a-quote":[null,"Request a Quote"],"services":[null,"Services"],"register":[null,"Create an Account"]};
  const linkDefaults = {"register":["Discuss your trade requirements","Product enquiry / quotation","Business account enquiry"],"help-support":["Request a quote","Product enquiry / quotation","New equipment requirement"],"order-a-custom-mounting-system":["Request a Quote","Product enquiry / quotation","Custom mounting system"]};
  const productSubject = 'Product enquiry / quotation';
  const generalSubject = 'Other — please describe below';
  const serviceSubjects = new Set(['Procurement & Sourcing', 'Logistics & Delivery', 'Technical & Project Support', 'Utility-Scale Solutions', 'Financing & Commercial Support', 'Partner Services']);
  const normalPath = path => path.replace(/^\/[a-z]{2,3}(?:-[a-z0-9]{2,8})*(?=\/(?:pages|collections|products|blogs|policies)(?:\/|$))/i, '').replace(/\/$/, '') || '/';
  const pagePath = normalPath(location.pathname);
  if (pagePath === '/pages/request-a-quote') return;
  // Infer context only from public content routes, never account, cart, search or submitted form values.
  if (!/^(?:\/|\/(?:pages|products|collections|blogs|policies)\/[^/]+(?:\/.*)?)$/.test(pagePath)) return;

  const plain = (value, limit = 300) => String(value || '').replace(/[<>\u0000-\u001f\u007f-\u009f\u200e\u200f\u202a-\u202e\u2066-\u2069]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, limit).replace(/[\uD800-\uDBFF]$/, '');
  const text = node => {
    if (!node) return '';
    const copy = node.cloneNode(true);
    copy.querySelectorAll('[hidden],[aria-hidden="true"],script,style,template,svg').forEach(child => child.remove());
    return plain(copy.textContent);
  };
  const heading = (root, selector) => text(root?.querySelector?.(selector));
  const quotePath = path => normalPath(path) === '/pages/request-a-quote';
  const source = (anchor, inContent) => {
    // Keep the source useful without copying search terms, contact details or marketing parameters.
    const path = location.pathname;
    const slug = '[a-z0-9]+(?:-[a-z0-9]+)*';
    const contentRoute = new RegExp('^/(?:pages/' + slug + '|products/' + slug + '|collections/' + slug + '(?:/products/' + slug + ')?|blogs/' + slug + '(?:/' + slug + ')?)/?$');
    // Match the form consumer's current English-route, 180-character source contract.
    if (path.length > 180 || (path !== '/' && !contentRoute.test(path))) return '';
    const chapter = inContent && anchor.closest('.bmg-discover__chapter[id],.bmg-services__chapter[id],.bmg-editorial__chapter[id],.bmg-discover__card[id],.bmg-services__card[id],[data-brand-card][id],[data-event-row][id],[data-brand-directory][id],.bmg-event-calendar[id],.bmg-discover__products[id]');
    const hash = chapter && /^[a-zA-Z0-9_.:-]+$/.test(chapter.id) ? '#' + chapter.id : '';
    return path + (path.length + hash.length <= 180 ? hash : '');
  };
  const contextFor = anchor => {
    const main = document.querySelector('main,[role="main"]');
    const inContent = !!anchor.closest('main,[role="main"]') && !anchor.closest('nav,[role="navigation"],footer');
    const pageHandle = pagePath.match(/^\/pages\/([^/]+)$/)?.[1];
    const mapped = pageHandle && pageDefaults[pageHandle];
    let subject = inContent ? mapped?.[0] : null;
    let context = mapped?.[1] || heading(main, 'h1');
    const chapter = inContent && anchor.closest('.bmg-discover__chapter');
    const isProduct = /^\/products\/[^/]+$/.test(pagePath) || /^\/collections\/[^/]+\/products\/[^/]+$/.test(pagePath);
    const isCollection = /^\/collections\/[^/]+$/.test(pagePath);
    const isEvent = /^\/blogs\/events(?:\/|$)/.test(pagePath) || pageHandle === 'events';

    if (isProduct) {
      // The active prelaunch snippet renders the real product title in this heading.
      const title = heading(main, '.bmg-prelaunch-page .bmg-discover__intro h1');
      if (title) { context = title; subject = inContent ? productSubject : null; }
    } else if (isCollection) {
      const brand = heading(main, '.bmg-discover-content article .bmg-discover__intro .bmg-discover__eyebrow');
      if (brand) {
        const chapterTitle = heading(chapter, 'h2');
        context = brand + (chapterTitle && chapterTitle !== brand ? ' — ' + chapterTitle : '');
        subject = inContent ? productSubject : null;
      }
    } else if (isEvent) {
      const row = inContent && anchor.closest('[data-event-row]');
      const card = inContent && anchor.closest('.bmg-discover__card');
      const eventTitle = heading(row, 'td[data-label="Event"] > strong') || heading(card, 'h2');
      context = eventTitle || heading(main, '.bmg-discover__intro h1') || context;
      subject = inContent ? generalSubject : null;
    }

    if (inContent && pageHandle === 'brands-manufacturers') {
      const brandCard = anchor.closest('[data-brand-card]');
      context = heading(brandCard, 'h2,h3') || context;
    }
    if (inContent && pageHandle === 'services') {
      const service = heading(anchor.closest('.bmg-services__card'), 'h2');
      if (serviceSubjects.has(service)) { subject = service; context = service; }
    }
    const linkDefault = inContent && pageHandle && linkDefaults[pageHandle];
    if (linkDefault && text(anchor).replace(/\s*[→↗]\s*$/, '') === linkDefault[0]) {
      subject = linkDefault[1];
    }
    return { subject, context: plain(context), source: source(anchor, inContent) };
  };
  const enhance = anchor => {
    const href = anchor.getAttribute('href');
    if (!href) return;
    let target;
    try { target = new URL(href, location.href); } catch { return; }
    if (!/^https?:$/.test(target.protocol) || target.origin !== location.origin || !quotePath(target.pathname)) return;
    const context = contextFor(anchor);
    if (!context.context) return;
    let changed = false;
    for (const [key, value] of Object.entries({ bmg_subject: context.subject, bmg_context: context.context, bmg_source: context.source })) {
      if (value && !target.searchParams.has(key)) { target.searchParams.set(key, value); changed = true; }
    }
    if (changed) anchor.setAttribute('href', target.pathname + target.search + target.hash);
  };
  const scan = root => {
    if (root.nodeType === Node.ELEMENT_NODE && root.matches('a[href]')) enhance(root);
    root.querySelectorAll?.('a[href]').forEach(enhance);
  };
  // Existing refinements above have already inserted their early enquiry links.
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  const observer = new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE) scan(node);
    }
  });
  // Only added elements need a scan; observing href changes would create unnecessary work.
  observer.observe(document.body, { childList: true, subtree: true });
})();
